const columns = [
    {
        label: 'Title',
        name: 'title'
    },
    {
        label: 'Name',
        name: 'name'
    },
    {
        label: 'Phone Number',
        name: 'phoneNumber'
    },
    {
        label: 'Action',
        name: 'action'
    }
]
export default columns
